var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSociallinkTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sociallink_twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sociallink_twitter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.352941176,28.6529887 C0.352941176,32.5157069 3.48505867,35.6470588 7.34701135,35.6470588 L28.6529887,35.6470588 C32.5157069,35.6470588 35.6470588,32.5149413 35.6470588,28.6529887 L35.6470588,7.34701135 C35.6470588,3.48429305 32.5149413,0.352941176 28.6529887,0.352941176 L7.34701135,0.352941176 C3.48429305,0.352941176 0.352941176,3.48505867 0.352941176,7.34701135 L0.352941176,28.6529887 Z",
    id: "Stroke-6",
    fillOpacity: 0.01,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6270588,12.4846588 C27.8915294,12.8107765 27.1002353,13.0317176 26.2701176,13.1305412 C27.1171765,12.6230118 27.768,11.8190118 28.0743529,10.8604235 C27.2816471,11.3305412 26.4035294,11.6721882 25.4682353,11.8564235 C24.0875294,10.3846588 21.6232941,9.93218824 19.3595294,11.7484235 C18.4447059,13.0500706 18.2018824,14.4237176 18.4757647,15.5990118 C15.0656471,15.4281882 12.0416471,13.7940706 10.0178824,11.3114824 C9.66423529,11.9178353 9.46235294,12.6223059 9.46235294,13.3747765 C9.46235294,14.7985412 10.1865882,16.0543059 11.2877647,16.7898353 C10.6150588,16.7686588 9.98188235,16.5844235 9.42917647,16.2766588 C9.40376471,18.2877176 10.8268235,19.9719529 12.72,20.3524235 C12.3762353,20.4463059 12.0134118,20.4964235 11.6392941,20.4964235 C11.3745882,20.4964235 11.1176471,20.4703059 10.8670588,20.4230118 C11.3894118,22.0528941 12.9049412,23.2394824 14.7007059,23.2726588 C13.296,24.3731294 11.5270588,25.0288941 9.60423529,25.0288941 C9.27317647,25.0288941 8.94635294,25.0098353 8.62517647,24.9717176 C10.4414118,26.1364235 12.5985882,26.8154824 14.916,26.8154824 C22.464,26.8154824 26.5912941,20.5627765 26.5912941,15.1394824 C26.5912941,14.9616 26.5870588,14.7851294 26.5792941,14.6086588 C27.3811765,14.0305412 28.0771765,13.3077176 28.6270588,12.4846588 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSociallinkTwitter);
export default __webpack_public_path__ + "static/media/sociallink_twitter.7d228ab680c4b58fd72effb1bc8a4095.svg";
export { ForwardRef as ReactComponent };